<template>
  <div class="bg-gray-800 rounded-t-none rounded-lg pb-2">
    <ul class="bg-gray-800 select-none">
      <li
        class="py-3 px-2 bg-gray-700 cursor-pointer"
        @click="
          setIsActiveAuto({ isActiveAuto: true })
          $emit('closeMenu')
        "
      >
        Automatiser pour cette question
      </li>
      <li
        class="py-3 px-2 bg-gray-800 cursor-pointer"
        @click="
          setIsActiveAuto({ isActiveAuto: true, isActiveForAllQuestions: false })
          $emit('closeMenu')
        "
      >
        Automatiser pour toutes les questions suivantes
      </li>
      <li
        class="py-3 px-2 bg-gray-700 cursor-pointer"
        @click="
          setIsActiveAuto({ isActiveAuto: true, isActiveForAllQuestions: true })
          $emit('closeMenu')
        "
      >
        Automatiser pour toutes les questions
      </li>
    </ul>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"

export default {
  computed: {
    ...mapState({
      timer: (state) => state.live.timer,
    }),
  },
  methods: {
    ...mapMutations("live", ["setIsActiveAuto"]),
  },
}
</script>

<style></style>
